<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <up-card
    class="section-card overflow-unset"
    :class="{
      'past-program': cssPastTime
      }"
  >
    <div :class="{ 'section__wrapper': true, 'isOpen': isOpenSection }">
      <div
        class="section-header"
        @click="toggleSection"
      >
        <div class="section-line">
          <p class="section-time">
            {{ timeStartEnd }}
          </p>
          <p class="section-place">
            {{ section.place }}
          </p>
        </div>
        <div
          v-if="timeProgress"
          class="section-line"
        >
          <div class="section-time-progress">
            <div
              class="time-progress"
              :style="{'width': `${timeProgress}%`}"
            ></div>
          </div>
        </div>
        <div class="section-line">
          <p class="section-title">
            {{ sectionTitle }}
          </p>
        </div>
      </div>
      <div class="section-body">
        <div
          v-if="isModerators"
          class="section-moderate">
          <span class="moderate-item">{{ $t('shared.lecture.moderator') }}:</span>
          <span
            v-for="moderator in section.moderators"
            :key="moderator.id"
            class="moderate-item"
          >
            {{ moderator.name}}
          </span>
        </div>
        <div
          v-if="isSpeakers"
          class="section-speaker">
          <i class="exu-mic"/>
          <router-link
            v-for="speaker in section.speakers"
            :key="speaker.id"
            :to="{ path: speakerLink(speaker.id) }"
            class="speaker-item"
          >
            {{ speaker. name}}
          </router-link>
        </div>
        <div
          v-if="isOpenSection"
          class="section-lecture"
        >
          <lecture-item
            v-for="lecture in section.lectures"
            :id="`s_${section.id}_l_${lecture.id}`"
            :key="`s_${section.id}_l_${lecture.id}`"
            :lecture="lecture"
            :moderators="section.moderators"
            :marked-lecture="isMarkedLecture(lecture.id)"
            :past-time-item="nowTime"
            :doScrollLecture = "doScrollItem && doScrollItem.lecture === `${lecture.id}`
              ? hashToScroll
              : null"
            @mark-lecture="markLectureFavorit"
          />
        </div>
        <div
          v-if="isNoBreake"
          class="section-line button-line"
        >
          <div class="col-3">
            <button
              @click="markFavorit"
              class="btn btn-sm btn-accent"
              :class="{ active: isMarkedSection }"
            >
            <i :class="{
              'exu-bookmark': !isMarkedSection,
              'exu-bookmark-check-fill': isMarkedSection
            }" />
            </button>
          </div>
          <div
            v-if="isBtnMore"
            class="col"
          >
            <button
              class="btn btn-sm btn-more"
              @click="toggleSection"
            >
              <i
                v-if="!isOpenSection"
                class="exu-chevron-down"
              />
              <i
                v-else
                class="exu-chevron-up"
              />
            </button>
          </div>
          <div
            v-if="isBtnMore"
            class="col-3"
          >
            <router-link
              :to="{ name: 'questions', params: { section_id: this.section.id } }"
              class="btn btn-sm btn-accent"
            >
              <i class="exu-msg-question-sq" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </up-card>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { DateTime } from 'luxon';

export default {
  name: 'SectionCard',
  // mixins: [calendar],
  props: {
    section: {
      type: Object,
      default: () => ({}),
    },
    markedId: {
      type: Array,
      default: () => ([]),
    },
    hashToScroll: null,
    doScrollItem: null,
    nowTime: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isOpenSection: false,
    };
  },
  computed: {
    checkLecture() {
      return !!this.lecture;
    },
    isNoBreake() {
      // TODO уточнить про тип section
      return this.section.type === 'lecture' || this.section.type === 'section';
    },
    timeStart() {
      return DateTime.fromMillis(this.section.start_ts).setZone(this.$store.getters.getTime_UTC);
    },
    timeEnd() {
      return this.timeStart.plus(this.section.duration_ts);
    },
    timeStartEnd() {
      return this.timeStart ? `${this.timeStart.toFormat('H:mm')} - ${this.timeEnd.toFormat('H:mm')}` : '';
    },
    dateEvent() {
      return this.timeStart
        ? this.timeStart.setLocale(this.$store.getters.getLang).toFormat('L MMMM')
        : '';
    },
    // sectionName() {
    //   return this.section.name
    // eslint-disable-next-line max-len
    //     ? `${this.section.name}${this.section.name[this.section.name.length - 1] !== '.' ? '.' : ''}`.trim()
    //     : null;
    // },
    sectionTitle() {
      const sectionName = this.section.name ? this.section.name : '';
      const sectionTitle = this.section.title ? this.section.title : '';
      const dotName = sectionName && sectionName[sectionName.length - 1] !== '.' ? '.' : '';
      const dotTitle = sectionTitle && sectionTitle[sectionTitle.length - 1] !== '.' ? '.' : '';
      const title = `${sectionName}${dotName} ${sectionTitle}${dotTitle}`;

      return title;
    },
    isBtnMore() {
      return this.section.lectures.length > 0;
    },
    isModerators() {
      return this.section.moderators.length > 0;
    },
    isSpeakers() {
      return this.section.speakers.length > 0 && !this.isOpenSection;
    },
    isMarkedSection() {
      return this.markedId.includes(this.section.id);
    },
    dataForMarkFavorit() {
      return {
        id: this.section.id,
        hashLink: `s_${this.section.id}`,
        start_ts: this.section.start_ts,
        duration_ts: this.section.duration_ts,
        place: this.section.place,
        main_title: this.sectionTitle,
        sub_title: null,
        moderators: this.isModerators ? this.section.moderators : [],
        speakers: this.isSpeakers ? this.section.speakers : [],
        type: 'section',
      };
    },
    isShowQuestion() {
      return false;
    },
    btnDetails() {
      const { app } = this.section.link;
      const params = !!app && app === 'sectionPage'
        ? { section_id: this.section.link.ident }
        : { alias: this.section.link.ident };

      return { app, params, icon: this.section.link.icon || 'exu-document' };
    },
    isShowDetails() {
      return !this.isShowQuestion && !!this.section.link;
    },
    // isShowDetailsNew() {
    //   return !this.isShowQuestion;
    // },
    cssPastTime() {
      return this.nowTime !== null
        ? this.section.start_ts + this.section.duration_ts < this.nowTime
        : false;
    },
    timeProgress() {
      if (this.nowTime !== null
        && this.section.start_ts < this.nowTime
        && this.timeEnd.toMillis() > this.nowTime) {
        // eslint-disable-next-line max-len
        const TIME_PROGRESS = (Math.round(((this.nowTime - this.section.start_ts) / this.section.duration_ts) * 100));
        return TIME_PROGRESS;
      }
      return 0;
    },
  },
  mounted() {
    if (this.doScrollItem) {
      if (!this.doScrollItem.lecture) {
        document.querySelector(`#s_${this.doScrollItem.section}`)
          .scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        this.isOpenSection = true;
      }
    }
  },
  methods: {
    // moderatorLink(id) {
    //   return `/speaker/profile/${id}`;
    // },
    speakerLink(id) {
      return `/speaker/profile/${id}`;
    },
    // разворачивать нечего, если у секции нет лекций
    toggleSection() {
      if (!this.isBtnMore) {
        return;
      }
      this.isOpenSection = !this.isOpenSection;
    },
    markFavorit() {
      this.$emit('mark-favorite', this.dataForMarkFavorit);
    },
    markLectureFavorit(data) {
      // console.log(data);
      const lectureData = data;
      lectureData.hashLink = `s_${this.section.id}_l_${data.id}`;
      lectureData.main_title = this.sectionTitle;
      lectureData.place = this.section.place;
      lectureData.moderators = this.isModerators ? this.section.moderators : [];

      this.$emit('mark-favorite', lectureData);
    },
    isMarkedLecture(_id) {
      return this.markedId.includes(_id);
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  &-card {
    scroll-margin-top: -80px;
  }
  &__wrapper {
    display: flex;
    padding: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    p {
      margin: 0;
      font-size: 14px;
      line-height: 130%; /* 18.2px */
      letter-spacing: -0.14px;
    }

    &.isOpen {
      .button-line {
        position: sticky;
        bottom: 0;
      }
    }
  }

  &-header {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  &-title {
    display: flex;
    justify-content: space-between;
    row-gap: 15px;
    color: #356899;
    // font-size: 14px;
    // line-height: 1.1rem;
    font-style: normal;
  }
  &-body {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  &-lecture {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
  &-line {
    display: flex;
    justify-content: space-between;
  }
  &-time, &-place {
    font-weight: 400;
    color: #356899;
    font-weight: 500;
  }

  &-time-progress {
    height: 3px;
    width: 100%;
    background: #F2F6FD;
  }
  &-time-progress .time-progress {
    height: 100%;
    background: #D76535;
    transition-property: width;
    transition-duration: .25s;
  }

  &-card.past-program &__wrapper &-time,
  &-card.past-program &__wrapper &-title,
  &-card.past-program &__wrapper &-place,
  &-card.past-program &__wrapper &-lecture *,
  &-card.past-program &__wrapper &-speaker .speaker-item {
    color: #95969D;
  }
}
.button-line {
  display: flex;
  flex-wrap: nowrap;
  // justify-content: center;
  margin: 0 -4px -4px;
  // padding: 8px 13px 4px;
  // padding-top: .5rem;
  // padding-bottom: .5rem;
  background: #FEFEFE;
  border-radius: 16px;
  gap: 8px;

  & div[class^='col'] {
    padding: 0;
    flex-shrink: 1;
  }

  & .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 36px;
    font-size: 1.25rem;
    // border-radius: 16px;
    background: #FFFFFF;
  }

  & > div:first-child > .btn {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
  }
  & > div:last-child > .btn {
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
  }
}
.section-speaker, .section-moderate {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  column-gap: 15px;
  color: #95969D;

  .speaker-item, .moderate-item {
    display: block;
    color: #2c3e50;
    font-size: 14px;
    text-decoration: none;
    outline: none;
    white-space: nowrap;

    &.current {
      color: #356899;
    }
  }
}
.btn-more {
  color: #356899;
  border: 2px solid #356899;

  &:active {
    color: #FFFFFF;
    background: #356899;
  }
}
.btn-accent {
  color: #D76535;
  border: 2px solid #D76535;

  &.active, &:active {
    color: #FFFFFF;
    background: #D76535;
  }
}
</style>
